import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { confirmDialog } from "primereact/confirmdialog";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

import { getTopNavbarMenus } from "../../helpers/top-navbar-helper";
import { handleLogout } from "../../../../store/authentication";
import ArrivedDepartedModal from "../Modals/ArrivedDepartedModal";
import QuickTicketViewModal from "../Modals/QuickTicketViewModal";
import { ROLE_TYPES } from "../../../../utility/constants";

export default function TopNavbarMenus({
    counterInfo,
    companyConfig,
    currentUser,
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [menus, setMenus] = useState([]);
    const [isArrivedDepartedModalOpen, setIsArrivedDepartedModalOpen] =
        useState(false);
    const [isQuickTicketViewModalOpen, setIsQuickTicketViewModalOpen] =
        useState(false);

    const isCompanyCallCenterManager =
        currentUser?.role_type === ROLE_TYPES.COMPANY_CALL_CENTRE_MANAGER;

    const openSignOutDialog = (event) => {
        event.preventDefault();
        confirmDialog({
            draggable: false,
            message: (
                <div className="flex items-center gap-x-1">
                    <InformationCircleIcon className="w-6 h-6" /> Are you sure
                    you want to sign out?{" "}
                </div>
            ),
            header: "Sign out Confirmation",
            defaultFocus: "reject",
            acceptClassName: "p-button-danger",
            accept: signOut,
        });
    };

    const signOut = async (event) => {
        dispatch(handleLogout());
        navigate("/login");
    };

    useEffect(() => {
        setMenus(getTopNavbarMenus());
    }, []);

    return (
        <>
            <nav className="flex justify-between flex-wrap bg-[#666E73] px-2 border-y border-[#2D444F] w-full max-lg:min-w-[930px]">
                <ul className="flex max-lg:flex-wrap">
                    {menus.map((menu, index) =>
                        menu.subMenus ? (
                            <li className="relative group nav-link-sep" key={index}>
                                <div className="flex items-center">
                                    <a
                                        href="javascript:void(0)"
                                        className="nav-link"
                                    >
                                        {menu.title}
                                    </a>
                                    <span className="text-white">|</span>
                                </div>
                                <ul className="mt-[-2px] hidden group-hover:flex translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 w-[189px] flex-col justify-center border border-[#bcbcbc] absolute top-[28px] z-50 transition-all duration-100 nav-sub">
                                    {menu.subMenus.map(
                                        (subMenu, subMenuIndex) => (
                                            <li
                                                className="nav-li-bg"
                                                key={`counter-panel-topbar-sub-menu-${subMenuIndex}`}
                                            >
                                                <Link
                                                    className="block text-xs text-black py-[9px] px-3 border-b border-[#d0dfe2]"
                                                    to={subMenu.url}
                                                >
                                                    {subMenu.title}
                                                </Link>
                                            </li>
                                        )
                                    )}
                                </ul>
                            </li>
                        ) : (
                            <li
                                className="flex items-center nav-link-sep"
                                key={`counter-panel-topbar-menu-${index}`}
                            >
                                <Link className="nav-link" to={menu.url}>
                                    {menu.title}
                                </Link>
                                <span className="text-white">|</span>
                            </li>
                        )
                    )}
                    <li className="flex items-center nav-link-sep">
                        <a
                            href="#"
                            onClick={openSignOutDialog}
                            className="nav-link"
                        >
                            Logout
                        </a>
                        <span className="text-white">|</span>
                    </li>
                    <li className="nav-link text-[10px] uppercase !text-[#FFFF00] font-bold">
                        {counterInfo?.title?.en
                            ? `${counterInfo.title.en} | `
                            : ""}
                        USER NAME: {currentUser?.username}
                    </li>
                </ul>
                <ul className="flex items-center ml-auto">
                    {!isCompanyCallCenterManager ? (
                        <li>
                            <button
                                className="text-[13px] text-white uppercase mr-1"
                                id="arrive_modal_btn"
                                onClick={() =>
                                    setIsArrivedDepartedModalOpen(true)
                                }
                            >
                                ARRIVED / DEPART STATUS |{" "}
                            </button>
                        </li>
                    ) : null}
                    <li>
                        <button
                            className="text-[13px] text-white uppercase"
                            id="ticket_view_btn"
                            onClick={() => setIsQuickTicketViewModalOpen(true)}
                        >
                            QUICK TICKET VIEW
                        </button>
                    </li>
                </ul>
            </nav>
            {isArrivedDepartedModalOpen ? (
                <ArrivedDepartedModal
                    visible={isArrivedDepartedModalOpen}
                    setVisible={setIsArrivedDepartedModalOpen}
                />
            ) : null}
            {isQuickTicketViewModalOpen ? (
                <QuickTicketViewModal
                    visible={isQuickTicketViewModalOpen}
                    setVisible={setIsQuickTicketViewModalOpen}
                    companyConfig={companyConfig}
                    counterInfo={counterInfo}
                />
            ) : null}
        </>
    );
}
